import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function EnquiryForm({ pageSource = 'home', variant = 'home', defaultCountry = '', visitorMode = false }){
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '', email: '', phone: '', nationality: '', current_location: '',
    income_range: '', family_situation: '', timeframe: '',
    countries_considering: defaultCountry,
    note: '',
  });

  const upd = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      await axios.post(`${API}/enquiries`, { ...form, page_source: pageSource });
      setStatus('done');
    } catch (err) {
      setStatus('error');
      setError(err?.response?.data?.detail || 'Something went wrong. Please try again.');
    }
  };

  if (status === 'done'){
    return (
      <div className="enq-form reveal in">
        <div className="form-success">
          <h3>Thank you.</h3>
          <p>We’ve received your enquiry. A member of our team will reply personally within one working day.</p>
        </div>
      </div>
    );
  }

  const isCountryForm = variant === 'country';

  return (
    <form className="enq-form reveal" onSubmit={onSubmit} data-testid="enquiry-form">
      <div className="form-title">{isCountryForm ? `Start my ${defaultCountry || 'application'}` : 'Request a conversation'}</div>
      <div className="form-sub">Takes about 60 seconds. We’ll reply within one working day.</div>
      {status === 'error' && <div className="admin-error" data-testid="form-error">{error}</div>}

      <div className="form-field">
        <label>Your name <em>*</em></label>
        <input required type="text" placeholder="First and last name" value={form.name} onChange={upd('name')} data-testid="input-name" />
      </div>

      <div className="form-row">
        <div className="form-field">
          <label>Email <em>*</em></label>
          <input required type="email" placeholder="you@email.com" value={form.email} onChange={upd('email')} data-testid="input-email" />
        </div>
        <div className="form-field">
          <label>WhatsApp (with country code) <em>*</em></label>
          <input required type="tel" placeholder="+44 7..." value={form.phone} onChange={upd('phone')} data-testid="input-phone" />
        </div>
      </div>

      <div className="form-row">
        <div className="form-field">
          <label>Passport nationality</label>
          <input type="text" placeholder="British, Indian, American..." value={form.nationality} onChange={upd('nationality')} data-testid="input-nationality" />
        </div>
        <div className="form-field">
          <label>Currently in</label>
          <input type="text" placeholder="London, Dubai, Mumbai..." value={form.current_location} onChange={upd('current_location')} data-testid="input-location" />
        </div>
      </div>

      <div className="form-row">
        <div className="form-field">
          <label>Monthly income</label>
          <select value={form.income_range} onChange={upd('income_range')} data-testid="input-income">
            <option value="">Select a range</option>
            <option>Under $3,000 / mo</option>
            <option>$3,000 – $5,000 / mo</option>
            <option>$5,000 – $8,000 / mo</option>
            <option>$8,000 – $15,000 / mo</option>
            <option>Over $15,000 / mo</option>
          </select>
        </div>
        <div className="form-field">
          <label>Family situation</label>
          <select value={form.family_situation} onChange={upd('family_situation')} data-testid="input-family">
            <option value="">Select one</option>
            <option>Applying alone</option>
            <option>With a spouse / partner</option>
            <option>With spouse and children</option>
            <option>Single parent with children</option>
          </select>
        </div>
      </div>

      {isCountryForm ? (
        <div className="form-field">
          <label>{visitorMode ? 'When do you want to travel?' : 'When would you like to move?'}</label>
          <select value={form.timeframe} onChange={upd('timeframe')} data-testid="input-timeframe">
            <option value="">Select a timeframe</option>
            <option>As soon as possible</option>
            <option>Within 3 months</option>
            <option>3–6 months from now</option>
            <option>6–12 months from now</option>
            <option>Just exploring for now</option>
          </select>
        </div>
      ) : (
        <div className="form-field">
          <label>Countries you’re considering</label>
          <input type="text" placeholder="Portugal, Spain, Dubai..." value={form.countries_considering} onChange={upd('countries_considering')} data-testid="input-countries" />
        </div>
      )}

      <div className="form-field">
        <label>A few words about your situation</label>
        <textarea placeholder="Are you moving alone or with family? Working remotely or freelance? Anything we should know..." value={form.note} onChange={upd('note')} data-testid="input-note" />
      </div>

      <button type="submit" className="btn-submit" disabled={status === 'loading'} data-testid="submit-enquiry">
        {status === 'loading' ? 'Sending...' : (isCountryForm ? 'Send enquiry →' : 'Send enquiry')}
      </button>
      <div className="form-foot">We typically reply within 4 hours. Always within one working day.</div>
    </form>
  );
}
